export default __webpack_public_path__ + "content/media/32.c00b3bcd.jpg";